export const constructUrlWithParams = (url) => {
  const { getSearch } = require('./location');
  const queryParams = getSearch(); // e.g., "?param=value"
  const [baseUrl, fragment] = url.split('#');
  const separator = baseUrl.includes('?') ? '&' : '?';
  const newUrl =
    baseUrl +
    (queryParams ? separator + queryParams.slice(1) : '') +
    (fragment ? `#${fragment}` : '');

  return newUrl;
};
